import * as React from 'react';
export const GBSvg = React.forwardRef(function GBSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        fillRule: 'nonzero',
        d: 'M14 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M13.5 2h.5a2 2 0 0 1 2 2l-2.5 2H16v4h-2.5l2.5 1.5v.5a2 2 0 0 1-2 2h-1l-3-2.5V14H6v-2.5L2.5 14H2a2 2 0 0 1-2-2l2.5-2H0V6h2.5L0 4a2 2 0 0 1 2-2h.5L6 4.5V2h4v2.5L13.5 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M13.764 2H14a2 2 0 0 1 2 2l-1 .8V4a1 1 0 0 0-1-1h-1.9l1.4-1h.264zM15 6h1v1h-1V6zM0 7V6h1v1H0zm1-2.2L0 4a2 2 0 0 1 2-2h.5l1.4 1H2a1 1 0 0 0-1 1v.8zM6 3V2h4v1H6zm9 7V9h1v1h-1zm0 .9 1 .6v.5a2 2 0 0 1-2 2h-1l-1.2-1H14a1 1 0 0 0 1-1v-1.1zM10 13v1H6v-1h4zm-6.1 0-1.4 1H2a2 2 0 0 1-2-2l1-.8v.8a1 1 0 0 0 1 1h1.9zM1 10H0V9h1v1z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M9 9v5H7V9H0V7h7V2h2v5h7v2H9Zm5.794-6.836c.399.173.73.471.944.846L12 6h-2l4.794-3.836ZM.262 3.01a2.01 2.01 0 0 1 .943-.846L6 6H4L.262 3.01Zm.943 10.826a2.008 2.008 0 0 1-.943-.846L4 10h2l-4.795 3.836Zm14.533-.846a2.008 2.008 0 0 1-.943.846L10 10h2l3.738 2.99Z',
      }),
    ),
  );
});
GBSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var GB = {
  category: 'flag',
  colorable: false,
  name: 'GB',
  svg: GBSvg,
};
